import { DateTime } from "luxon"

// SPEC-045 K1-grace / SPEC-053 R20: is the analysis inside the one-day MANUAL grace window?
// Its EARLIEST task start must fall in [yesterday 00:00, today 00:00) in the team timezone.
// Mirrors backend common.started_yesterday exactly (get_lock_boundary(tz) → today 00:00;
// yesterday = that minus one day; inside iff yesterday <= earliest < today). Returns false when
// the analysis started 2+ days ago, is a manually-locked future analysis (earliest >= today
// 00:00), or has no dated tasks. The grace is manual-only and covers exactly two actions: adding
// a straggler sample (K1, "Add Samples") and unplanning an unfinished sample (R20, both unplan
// entry points) — automation (Fill-In/IAP) and move-off/delete/unlock never consult this.
// SPEC-046 (F1): reads the authoritative `analysis.earliestTaskStart` (serialized by the backend
// as the min task start over ALL tasks, SPEC-047) instead of scanning the date-windowed
// `state.analysisTasks` store, which only holds the tasks of the currently fetched schedule
// window and therefore mis-judged analyses whose earliest task lay outside it.
export function isWithinOneDayLockGrace(analysis, teamTimeZone) {
  if (!analysis?.earliestTaskStart) return false
  const today = DateTime.now().setZone(teamTimeZone).startOf("day")
  const yesterday = today.minus({ days: 1 })
  const earliest = DateTime.fromISO(analysis.earliestTaskStart)
  return earliest >= yesterday && earliest < today
}
